import React from 'react';
import { UnifiedMessageList, type UnifiedThreadMessageListProps } from '@/components/Messenger/unified/UnifiedMessageList';

export type DirectMessageListProps = Omit<UnifiedThreadMessageListProps, 'variant'>;

export const DirectMessageList = React.memo(function DirectMessageList(props: DirectMessageListProps) {
  return <UnifiedMessageList variant="thread" {...props} />;
});
